// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"loginform_fieldset__15TGF","options":"loginform_options__3D7Ku","form":"loginform_form__nWiG_"};